import {ApplicationSettings} from "@icure/api";
import {AppSettingsEnum} from "../services/application-settings.service";

export function getAppSetting(appSettingList: ApplicationSettings[], appSettingType: string[]): ApplicationSettings[] | [] {
  //@ts-ignore
  const settings = appSettingList?.filter(as => appSettingType?.includes(as?._id)) || [];
  return settings;
}

export function getAppSettingContent(appSetting: ApplicationSettings) {
  return appSetting?.settings!!
}
